import React from 'react'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { lifecycle } from 'recompose'


const MONTH_LIST = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]

const BasisReport = ({ monthList, setReport, treatmentByOrder, treatmentByPayment }) => {
    return (
        <div>
            <ContentBox title="Y2D">
                <Row>
                    <Column>
                        <h2>Kits (by payment date)</h2>
                        <table className="default-table">
                            <thead>
                                <tr>
                                    <th/>
                                    {monthList.map((month, index) => {
                                        return <th className="align-right" key={index}>{MONTH_LIST[month.month - 1]}</th>
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {setReport.map((row, index) => {
                                    return (<tr className="spacer-bottom" key={index}>
                                        {row.map((cell, cellIndex) => {
                                            const className = cellIndex !== 0 ? 'align-right' : ''
                                            return <td className={className} key={cellIndex}>{cell}</td>
                                        })}

                                    </tr>)
                                })}
                            </tbody>
                        </table>


                        <br/><br/>
                        <h2>Treatments (by order date)</h2>
                        <table className="default-table">
                            <thead>
                                <tr>
                                    <th/>
                                    {monthList.map((month, index) => {
                                        return <th className="align-right" key={index}>{MONTH_LIST[month.month - 1]}</th>
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {treatmentByOrder.map((row, index) => {
                                    return (<tr className="spacer-bottom" key={index}>
                                        {row.map((cell, cellIndex) => {
                                            const className = cellIndex !== 0 ? 'align-right' : ''
                                            return <td className={className} key={cellIndex}>{cell}</td>
                                        })}

                                    </tr>)
                                })}
                            </tbody>
                        </table>


                        <br/><br/>
                        <h2>Treatments (by payment) **reliable after june**</h2>
                        <table className="default-table">
                            <thead>
                                <tr>
                                    <th/>
                                    {monthList.map((month, index) => {
                                        return <th className="align-right" key={index}>{MONTH_LIST[month.month - 1]}</th>
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {treatmentByPayment.map((row, index) => {
                                    return (<tr className="spacer-bottom" key={index}>
                                        {row.map((cell, cellIndex) => {
                                            const className = cellIndex !== 0 ? 'align-right' : ''
                                            return <td className={className} key={cellIndex}>{cell}</td>
                                        })}

                                    </tr>)
                                })}
                            </tbody>
                        </table>


                    </Column>
                </Row>
            </ContentBox>
        </div>)
}


export default lifecycle({
    componentDidMount () {
        this.props.fetchBasisReport()
    },
})(withLayout(BasisReport))





// WEBPACK FOOTER //
// ./src/modules/analytics/component/basis/BasisReport.js